var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { doGetJSON } from '../base/util/httpUtils';
import { isInBreakoutRoom } from '../breakout-rooms/functions';
/**
 * Determines whether Salesforce is enabled for the current conference.
 *
 * @param {IReduxState} state - The redux store, the redux
 * {@code getState} function, or the redux state itself.
 * @returns {boolean}
 */
export const isSalesforceEnabled = (state) => {
    const { salesforceUrl } = state['features/base/config'];
    const isBreakoutRoom = isInBreakoutRoom(state);
    return Boolean(salesforceUrl) && !isBreakoutRoom;
};
/**
 * Fetches the Salesforce records that were most recently interacted with.
 *
 * @param {string} url - The endpoint for the session records.
 * @param {string} jwt - The JWT needed for authentication.
 * @returns {Promise<any>}
 */
export function getRecentSessionRecords(url, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        return doGetJSON(`${url}/records/recents`, true, {
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
    });
}
/**
 * Fetches the Salesforce records that match the search criteria.
 *
 * @param {string} url - The endpoint for the session records.
 * @param {string} jwt - The JWT needed for authentication.
 * @param {string} text - The search term for the session record to find.
 * @returns {Promise<any>}
 */
export function searchSessionRecords(url, jwt, text) {
    return __awaiter(this, void 0, void 0, function* () {
        return doGetJSON(`${url}/records?text=${text}`, true, {
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
    });
}
/**
* Fetches the Salesforce record details from the server.
*
* @param {string} url - The endpoint for the record details.
* @param {string} jwt - The JWT needed for authentication.
* @param {Object} item - The item for which details are being retrieved.
* @returns {Promise<any>}
*/
export function getSessionRecordDetails(url, jwt, item) {
    return __awaiter(this, void 0, void 0, function* () {
        const fullUrl = `${url}/records/${item === null || item === void 0 ? void 0 : item.id}?type=${item === null || item === void 0 ? void 0 : item.type}`;
        return doGetJSON(fullUrl, true, {
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
    });
}
/**
* Executes the meeting linking.
*
* @param {string} url - The endpoint for meeting linking.
* @param {string} jwt - The JWT needed for authentication.
* @param {string} sessionId - The ID of the meeting session.
* @param {Object} body - The body of the request.
* @returns {Object}
*/
export function executeLinkMeetingRequest(url, jwt, sessionId, body) {
    return __awaiter(this, void 0, void 0, function* () {
        const fullUrl = `${url}/sessions/${sessionId}/records/${body.id}`;
        const res = yield fetch(fullUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify(body)
        });
        const json = yield res.json();
        return res.ok ? json : Promise.reject(json);
    });
}
